module.exports = __webpack_public_path__ + "img/icon-account-pin-green@3x.e9842227.png";